import React, { Fragment } from "react";
import PropTypes from "prop-types";

const propTypes = {
  variant: PropTypes.oneOf(["full"]),
  color: PropTypes.string
};

const defaultProps = {
  variant: "full",
  color: "var(--bs-primary)"
};

const Logo = ({ variant, color, ...props }) => {
  return (
    <Fragment>
      {variant === "full" && (
        <svg
          width="78"
          height="24"
          fill="none"
          viewBox="0 0 78 24"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M66.0961 2.40447C66.3135 1.4854 67.4831 1.48653 67.7036 2.39849C68.2699 4.74073 69.2144 7.31972 70.7548 8.87699C72.3477 10.4874 75.0195 11.4482 77.3974 12.014C78.2009 12.258 78.2009 13.3658 77.3974 13.5569C75.0195 14.1227 72.3477 15.0835 70.7548 16.6939C69.1619 18.3043 68.2115 21.0055 67.6519 23.4095C67.4676 24.2014 66.3083 24.1938 66.1257 23.4095C65.5661 21.0055 64.6157 18.3043 63.0228 16.6939C61.4825 15.1366 58.9332 14.1868 56.6164 13.6142C55.6911 13.3855 55.6954 12.2078 56.6206 11.984C58.949 11.421 61.5135 10.478 63.06 8.91457C64.6064 7.35112 65.5392 4.75844 66.0961 2.40447Z"
            fill={color}
          />
          <path
            d="M7.47144 7.57172C7.47144 6.23384 8.41272 5.5649 9.55991 5.5649C10.56 5.5649 11.0601 5.83856 11.7366 6.5075L13.5604 2.91955C12.1484 1.85533 10.8836 1.36883 8.91278 1.36883C5.41238 1.36883 2.82385 3.6189 2.82385 7.51091V7.87578H0V11.9198H2.82385V23.2614H7.47144V11.9198H11.8543V7.87578H7.47144V7.57172Z"
            fill={color}
          />
          <path
            d="M14.0682 23.2614H18.7158V1.55127H14.0682V23.2614Z"
            fill={color}
          />
          <path
            d="M31.3272 7.87578L31.5331 8.97041H31.386C30.5918 8.21025 29.4446 7.57172 27.7385 7.57172C23.7675 7.57172 20.2083 11.0076 20.2083 15.5686C20.2083 20.1295 23.7675 23.5654 27.7385 23.5654C29.4446 23.5654 30.5918 22.9269 31.386 22.1668H31.5331L31.3272 23.2614H36.0336V7.87578H31.3272ZM28.3268 19.2173C26.2384 19.2173 24.8853 17.6362 24.8853 15.5686C24.8853 13.501 26.2384 11.9198 28.3268 11.9198C29.6505 11.9198 30.7389 12.4671 31.386 13.3793V17.7578C30.7389 18.67 29.6505 19.2173 28.3268 19.2173Z"
            fill={color}
          />
          <path
            d="M40.0079 5.92978C41.6257 5.92978 42.9788 4.71352 42.9788 2.94996C42.9788 1.2168 41.5963 -0.0298616 40.0079 0.000544297C38.3607 0.0309502 37.0958 1.2472 37.0958 2.94996C37.0958 4.71352 38.3901 5.92978 40.0079 5.92978ZM37.7429 23.2614H42.3905V7.87578H37.7429V23.2614Z"
            fill={color}
          />
          <path
            d="M52.8231 7.57172C51.1464 7.57172 49.7639 8.33188 48.7932 9.36569H48.705L48.9109 7.87578H44.2045V23.2614H48.8226L48.852 13.7746C49.558 12.5888 50.7052 11.9806 52.2642 11.9806C52.9113 11.9806 53.7055 12.1631 54.1468 12.4367V7.69334C53.7055 7.60212 53.2349 7.57172 52.8231 7.57172Z"
            fill={color}
          />
        </svg>
      )}
    </Fragment>
  );
};

Logo.propTypes = propTypes;
Logo.defaultProps = defaultProps;

export default Logo;
